module.exports = "/images/vendor/flag-icon-css/flags/1x1/ms.svg?ad88044d48d7c401d3bec290c5048a0b";